var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.GENERATED_FILE_TYPE = {
    INVOICE: 'INVOICE',
    INVOICE_XLS: 'INVOICE_XLS',
    PRICELIST_PDF: 'PRICELIST_PDF',
    INSURER_USERS: 'INSURER_USERS',
    ORDER_BILLS_NOT_ARCHIVED: 'ORDER_BILLS_NOT_ARCHIVED',
    ORDER_EVENTS_PDF: 'ORDER_EVENTS_PDF',
    COMMITTAL: 'COMMITTAL',
    DECISION: 'DECISION',
    CONTACT_REQUEST: 'CONTACT_REQUEST',
    EXAMINATION_COMMITAL: 'EXAMINATION_COMMITAL',
    FULL_BILL: 'FULL_BILL',
    BILL_ATTACHMENT: 'BILL_ATTACHMENT',
    BILL_XLS_REPORT: 'BILL_XLS_REPORT',
    TRANSACTION_REPORT: 'TRANSACTION_REPORT',
    PORTAL_USER_REGISTRATION_REPORT: 'PORTAL_USER_REGISTRATION_REPORT',
    WP_INVOICE: 'WP_INVOICE'
};

Object.freeze(Enum.MEEDY.GENERATED_FILE_TYPE);